export default "__VITE_ASSET__8a8f640b__"